import { render } from "./XlsxRow.vue?vue&type=template&id=705ea370"
import script from "./XlsxRow.vue?vue&type=script&lang=ts"
export * from "./XlsxRow.vue?vue&type=script&lang=ts"
script.render = render

export default script